import { useQuery } from "@tanstack/react-query";
export const useGetOrgStructure = (fetchApi, countryCode, signal, enabled = true) => {
    const { data, refetch, isLoading } = useQuery({
        queryKey: ["org-structure", countryCode],
        enabled,
        structuralSharing: false,
        queryFn: async () => {
            try {
                const res = await fetchApi.jsonInJsonOut(`/organisation/${countryCode}`, { signal });
                const units = Array.isArray(res?.payload) ? res.payload : [];
                return units;
            }
            catch (error) {
                console.error("Error fetching org structure: %o", error);
                return undefined;
            }
        },
    });
    return {
        data,
        isLoading,
        refetch,
    };
};
//# sourceMappingURL=orgApi.js.map